import { useEffect, useState } from 'react';
import { inferPositions } from './championPositions';

// 从 Riot DataDragon 拉取最新版本号 + 全英雄列表。
// 完全前端直连 CDN，不依赖项目后端，所以教练模式开箱即用。
const VERSIONS_URL = 'https://ddragon.leagueoflegends.com/api/versions.json';
const championListUrl = (version, locale) =>
  `https://ddragon.leagueoflegends.com/cdn/${version}/data/${locale}/champion.json`;
const squareImgUrl = (version, idName) =>
  `https://ddragon.leagueoflegends.com/cdn/${version}/img/champion/${idName}.png`;
const loadingImgUrl = (idName) =>
  `https://ddragon.leagueoflegends.com/cdn/img/champion/loading/${idName}_0.jpg`;
const splashImgUrl = (idName) =>
  `https://ddragon.leagueoflegends.com/cdn/img/champion/splash/${idName}_0.jpg`;

const useChampionData = (locale = 'zh_CN') => {
  const [champions, setChampions] = useState([]);
  const [version, setVersion] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const versionsRes = await fetch(VERSIONS_URL);
        const versions = await versionsRes.json();
        const latest = versions[0];

        const champRes = await fetch(championListUrl(latest, locale));
        if (!champRes.ok) {
          throw new Error(`DataDragon ${locale} 列表加载失败：HTTP ${champRes.status}`);
        }
        const champJson = await champRes.json();

        const list = Object.values(champJson.data).map((c) => ({
          id: Number(c.key),
          idName: c.id,
          name: c.name,
          title: c.title,
          tags: c.tags || [],
          positions: inferPositions(c.id, c.tags || []),
          // 拼音搜索辅助：c.id 本身就是英文标识，足够覆盖英文/拼音首字母模糊搜索
          search: `${c.name} ${c.id} ${c.title}`.toLowerCase(),
          squareImg: squareImgUrl(latest, c.id),
          loadingImg: loadingImgUrl(c.id),
          splashImg: splashImgUrl(c.id),
        }));

        list.sort((a, b) => a.name.localeCompare(b.name, 'zh-CN'));

        if (!cancelled) {
          setVersion(latest);
          setChampions(list);
          setLoading(false);
        }
      } catch (e) {
        if (!cancelled) {
          setError(e.message || String(e));
          setLoading(false);
        }
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [locale]);

  return { champions, version, loading, error };
};

export default useChampionData;
